export enum DeleteOrDeactivateEnum {
  DELETE = 'Delete',
  DEACTIVATE = 'Deactivate'
}
